(function ($) {
  'use strict';

  const sidebar = document.querySelector('.sidebar-nav');

  window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
      sidebar.classList.add('is-scrolled');
    } else {
      sidebar.classList.remove('is-scrolled');
    }
  });

  let memberMobileMenuToggle = null;
  let memberMobileMenu = null;
  let memberMobileMenuOverlay = null;

  function createOverlay() {
    if (!memberMobileMenuOverlay) {
      memberMobileMenuOverlay = $(
        '<div class="member-mobile-menu-overlay"></div>'
      );
      $('body').append(memberMobileMenuOverlay);
    }
  }

  function openMemberMobileMenu() {
    if (!memberMobileMenu || !memberMobileMenuToggle) return;

    createOverlay();

    memberMobileMenuToggle.attr('aria-expanded', 'true');
    memberMobileMenu.addClass('is-open');
    memberMobileMenuOverlay.addClass('is-open');
    $('body').addClass('member-mobile-menu-open');

    // Manage closing with Escape key and clicking outside
    $(document)
      .on('keyup.memberMobileMenu', function (event) {
        if (event.keyCode === 27) {
          closeMemberMobileMenu();
        }
      })
      .on(
        'click.memberMobileMenu',
        memberMobileMenuOverlay,
        closeMemberMobileMenu
      );
  }

  function closeMemberMobileMenu() {
    if (!memberMobileMenu || !memberMobileMenuToggle) return;

    memberMobileMenuToggle.attr('aria-expanded', 'false');
    memberMobileMenu.removeClass('is-open');
    if (memberMobileMenuOverlay) {
      memberMobileMenuOverlay.removeClass('is-open');
    }
    $('body').removeClass('member-mobile-menu-open');

    // Remove event listeners
    $(document).off('keyup.memberMobileMenu click.memberMobileMenu');

    // Return focus to the toggle button
    memberMobileMenuToggle.focus();
  }

  function toggleMemberMobileMenu(event) {
    event.preventDefault();
    event.stopPropagation();

    if (memberMobileMenu.hasClass('is-open')) {
      closeMemberMobileMenu();
    } else {
      openMemberMobileMenu();
    }
  }

  function initMemberMobileMenu() {
    // Check if we are in the member area and on mobile
    if (!$('.member-template-layout').length) return;

    memberMobileMenuToggle = $('.member-mobile-menu-toggle');
    memberMobileMenu = $('#member-mobile-menu');

    if (memberMobileMenuToggle.length && memberMobileMenu.length) {
      // Handle click on the toggle button
      memberMobileMenuToggle.on('click', toggleMemberMobileMenu);

      // Close the menu if a link is clicked
      memberMobileMenu
        .find('.member-mobile-menu__link')
        .on('click', function () {
          setTimeout(closeMemberMobileMenu, 100); // Let the link trigger naturally then close the menu
        });

      // Handle window resize
      $(window).on('resize.memberMobileMenu', function () {
        if ($(window).width() > 1360) {
          closeMemberMobileMenu();
        }
      });
    }
  }

  // Clean up on page unload
  function cleanup() {
    $(document).off('keyup.memberMobileMenu click.memberMobileMenu');
    $(window).off('resize.memberMobileMenu');
    if (memberMobileMenuOverlay) {
      memberMobileMenuOverlay.remove();
    }
  }

  // Initialize when the DOM is ready
  $(document).ready(function () {
    initMemberMobileMenu();
  });

  // Clean up before leaving the page
  $(window).on('beforeunload', cleanup);
})(jQuery);
